export default __webpack_public_path__ + "static/media/Lora-SemiBoldItalic.713a5ca1.ttf";